/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_ArchivedInputs */

const cs_pipelines_archived = /** @type {(inputs: Pipelines_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivováno`)
};

const en_pipelines_archived = /** @type {(inputs: Pipelines_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived`)
};

/**
* | output |
* | --- |
* | "Archived" |
*
* @param {Pipelines_ArchivedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_archived = /** @type {((inputs?: Pipelines_ArchivedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_ArchivedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_archived(inputs)
	return cs_pipelines_archived(inputs)
});